import React, { useContext } from 'react';
import RockstarGamesLogo from '../assets/Rockstar_Games_Logo 1.png';
import GTA6Logo from '../assets/GTA6-Logo-PNG 1.png';
import PS5Logo from '../assets/ps5-playstation-5-logo-0 1.png';
import XboxSeriesLogo from '../assets/xbox_x 1.png';
import { Theme } from '../App';

export default function Footer() {
    const { theme } = useContext(Theme);

    return (
        <footer className="footer">
            <div className={`footer__buttons ${theme}`}>
                <p className={`footer__buttons__text ${theme}`}>
                    Watch the official trailers of <strong>Grand Theft Auto VI</strong>
                </p>
                <div className="footer__buttons__container">
                    <a className={`footer__button ${theme}`}
                        href="https://youtu.be/QdBZY2fkU-0?si=ivvtI4HBSrHTMt9w"
                        target='"_blank'>
                        <strong>Trailer 1</strong>
                    </a>
                    <a className={`footer__button ${theme}`}
                        href="https://youtu.be/VQRLujxTm3c?si=m0-eQgabjc7hdeeO"
                        target='"_blank'>
                        <strong>Trailer 2</strong>
                    </a>
                </div>
            </div>
            <div className="footer__logos">
                <a href="https://www.rockstargames.com">
                    <img src={RockstarGamesLogo} alt="Rockstar Games logo" />
                </a>
                <a href="https://www.rockstargames.com/VI">
                    <img src={GTA6Logo} alt="Grand Theft Auto 6 logo" />
                </a>
                <a href="https://www.playstation.com/">
                    <img src={PS5Logo} alt="PlayStation 5 logo" />
                </a>
                <a href="https://www.xbox.com">
                    <img src={XboxSeriesLogo} alt="Xbox Series X/S logo" />
                </a>
            </div>
            <div className={`footer__bottom ${theme}`}>
                <p className={`footer__bottom__developed ${theme}`}>
                    Developed by <strong><a href="https://x.com/Pingooin">Shadix</a></strong> on <strong>December 5, 2023</strong>
                </p>
                <p className={`footer__bottom__developed ${theme}`}>
                    Not affiliated with <strong><a href="https://www.rockstargames.com">Rockstar Games®</a></strong>
                </p>
            </div>
        </footer>
    )
}